// extracted by mini-css-extract-plugin
export default {"container":"order-page_container__m3Cdk"};